import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';
import {
  HTTPS_REQUEST_OPTIONS,
  HTTPS_REQUEST_OPTIONS_FOR_FILES
} from '@constants/https-request-options/https-request-options';
import {Notification} from '@models/header/notification';

@Injectable({
  providedIn: 'root'
})
export class HeaderNotificationService {

  private GET_NOTIFICATION_URL_SUFFIX: string = '/api/web/notification/unread';
  private UPDATE_NOTIFICATION_URL_SUFFIX: string = '/api/web/notification/update';
  private UPDATE_NOTIFICATIONS_URL_SUFFIX: string = '/api/web/notification/updateList';

  private readonly BASE_URL: string;

  constructor(private http: HttpClient, private apiLocationService: ApiLocationService) {
    this.BASE_URL = this.apiLocationService.getLocation();
  }

  public getNotifications(): Observable<any> {
    const url: string = this.BASE_URL + this.GET_NOTIFICATION_URL_SUFFIX;
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public removeNotification(notification: Notification): Observable<any> {
    notification.read = true;
    if (!notification.parentId) {
      notification.parentId = -1;
    }
    const url: string = this.BASE_URL + this.UPDATE_NOTIFICATION_URL_SUFFIX;
    return this.http.post(url, notification, HTTPS_REQUEST_OPTIONS_FOR_FILES);
  }

  public removeAllNotifications(notifications: Notification[]): Observable<any> {
    for (const notification of notifications) {
      notification.read = true;
      if (!notification.parentId) {
        notification.parentId = -1;
      }
    }
    const url: string = this.BASE_URL + this.UPDATE_NOTIFICATIONS_URL_SUFFIX;
    return this.http.post(url, notifications, HTTPS_REQUEST_OPTIONS_FOR_FILES);
  }
}
